import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  standalone: true,
})
export class SortByPipe implements PipeTransform {
  transform(list: any[], field: string, direction = 'asc'): any[] {
    return list.sort((a, b) => {
      const comparison = a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0;
      return direction === 'asc' ? comparison : -comparison;
    });
  }
}
